import XMLParser from 'react-xml-parser';

const parser=new XMLParser();
export const parseList=(data)=>{
    const obj=parser.parseFromString(data);
    return obj.children
        .filter(child=>child.name==="Contents")
        .map(child=>{return{key:child.children[0].value,
               lastModified:child.children[1].value}})
        .sort((val1,val2)=>new Date(val2.lastModified) - new Date(val1.lastModified));
};

const transformName=(name)=>{
    return name.replace('-','');
};
const pushTag=(obj,source)=>{
    const key=source.children[0].value;
    obj[transformName(key)]=source.children[1].value;
};
export const parseKey=(key,data)=>{
    const obj=parser.parseFromString(data);
    for(let i=0; i<obj.children[0].children.length;i++){
        pushTag(key,obj.children[0].children[i]);
    }
    return key;
};

